import { styled } from "goober";
import { useComposerStrip } from "../../hooks/useComposerStrip";
import { mobileMedia } from "../../hooks/useIsMobile";
import { ClickButton } from "../ClickButton";
import { Icon } from "../Icon";

// Revealed by hovering the whole composer input, which each composer tags with [data-composer].
const IconWrap = styled("span")`
  display: flex;
  opacity: 0;
  transition: opacity var(--motion-base) var(--ease-out);
  [data-composer]:hover & {
    opacity: 0.4;
  }
  ${mobileMedia} {
    opacity: 0.4;
  }
`;

const Hint = styled("span")`
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: var(--text-secondary);
  background-color: transparent;
  transform: translate(-50%, calc(-50% + 4px));
  transition:
    background-color var(--motion-base) var(--ease-out),
    transform var(--motion-base) var(--ease-out);
  [data-composer]:hover & {
    background-color: var(--alpha4);
    transform: translate(-50%, -50%);
  }
  ${mobileMedia} {
    background-color: var(--alpha4);
    transform: translate(-50%, -50%);
  }
`;

// Collapsing on pointerdown moves the textarea under the remaining tap.
const ToggleButton = styled(ClickButton)`
  flex: 1;
  align-self: stretch;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export function ComposerStripToggle() {
  const { open, toggle } = useComposerStrip();
  return (
    <ToggleButton
      data-no-pill
      aria-label="Chat settings"
      aria-expanded={open}
      onMouseDown={(e) => e.preventDefault()}
      onClick={toggle}
    >
      <Hint>
        <IconWrap>
          <Icon
            name="chevron-up"
            size={12}
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform var(--motion-base) var(--ease-out)",
            }}
          />
        </IconWrap>
      </Hint>
    </ToggleButton>
  );
}
